import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-gwnb5x-0"
})(["display:block;position:fixed;z-index:200;bottom:140px;right:18px;padding:8px 16px;border-radius:", ";box-shadow:", " 0 0 0 2px;cursor:pointer;background-color:#fff;color:", ";svg{margin-right:8px;vertical-align:middle;}transition:0.12s ease all;:hover{bottom:135px;padding:12px 20px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.ui;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.font;
});